<template>
  <div class="region-select-com">
    <el-row class="m-b-10 title-ct">
      <el-col :span="10">
        <slot name="title">
          <h3 class="l-h-28 color-000">区域选择</h3>
        </slot>
      </el-col>
      <el-col :span="14">
        <el-input
          placeholder="请输入区域名称"
          size="small"
          v-model="filter_text"
        >
        </el-input>
        <!-- <el-autocomplete
          class="search-input"
          size="small"
          v-model="search_region"
          :fetch-suggestions="querySearchAsync"
          placeholder="请输入区域名称"
          :trigger-on-focus="false"
          suffix-icon="el-icon-search"
          @select="handleSelect"
        ></el-autocomplete> -->
      </el-col>
    </el-row>
    <div class="region-ct bg-fff">
      <el-tree
        ref="tree"
        :data="regions"
        show-checkbox
        :filter-node-method="filterNode"
        :node-key="defaultProps.value"
        :default-checked-keys="defExpKeys"
        :default-expanded-keys="defExpKeys"
        :default-expand-all="isExpand"
        @check="checkChange"
        :props="defaultProps"
      >
      </el-tree>
    </div>
  </div>
</template>
<script>
export default {
  name: "RegionSelectCom",
  props: {
    regions: {
      type: [Array, Object],
      default: () => []
    },
    defaultProps: {
      type: Object,
      default: () => ({
        children: "children",
        label: "label",
        value: "code"
      })
    },
    queryRegions: {
      type: Array,
      default: () => []
    },
    defExpKeys: {
      type: Array,
      default: () => ["150000"]
    },
    mode: {
      type: Number,
      default: () => 1
    }
  },
  data() {
    return {
      filter_text: "",
      search_region: "",
      isExpand: false
    };
  },
  watch: {
    filter_text(val) {
      this.$refs.tree.filter(val);
    }
  },
  methods: {
    filterNode(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },
    checkChange(node, data) {
      //a是当前的
      if (data.checkedNodes.length != 0 && this.mode == 1) {
        //单选模式
        this.$refs.tree.setCheckedKeys([]);
        this.$refs.tree.setCheckedKeys([node.code]);
        let keys = this.getCheckedKeys();
        this.$emit("checkChange", keys[0]);
      } else {
        let keys = this.getCheckedKeys(true);
        this.$emit("checkChange", keys);
      }
    },
    getCheckedNodes(leaf, half) {
      return this.$refs.tree.getCheckedNodes(leaf, half);
    },
    getCheckedKeys(leaf) {
      return this.$refs.tree.getCheckedKeys(leaf);
    },
    querySearchAsync(queryString, cb) {
      var queryRegions = this.queryRegions;
      var results = queryString
        ? queryRegions.filter(this.createStateFilter(queryString))
        : queryRegions;
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        cb(results);
      }, 1000 * Math.random());
    },
    createStateFilter(queryString) {
      return state => {
        return (
          state.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0
        );
      };
    },
    handleSelect(item) {
      //选择对应的node
      if (this.mode == 1) {
        this.$refs.tree.setCheckedKeys([]);
      }
      this.$refs.tree.setChecked(item.id, true, true);
    },
    setCheckedNodes(data) {
      this.$refs.tree.setCheckedNodes(data);
    }
  }
};
</script>
<style lang="less" scoped>
.region-select-com {
  .l-h-28 {
    line-height: 0.28rem;
  }
  .region-ct {
    height: 1.6rem;
    overflow-y: auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/RegionSelectCom/RegionSelectCom.vue